import React from 'react';

const GlobalContent = () => {

    return (
        <div className="section">
            <h2>Global Content</h2>
        </div>
    );
};

export default GlobalContent;
